import React, { useState, useEffect } from "react";
import {
  Collapse,
  Card,
  Grid,
  Button,
  Typography,
  CircularProgress
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSimilarCasesData } from "components/CaseManagement/SimilarCases/SimilarCasesContext";
import { SimilarCasesFilters } from "components/CaseManagement/SimilarCases/SimilarCasesFilters";
import { SimilarCaseDetail } from "components/CaseManagement/SimilarCases/SimilarCaseDetail";
import { SimilarCasesTable } from "components/CaseManagement/SimilarCases/SimilarCasesTable";
import { ReactComponent as SimilarCasesIcon } from "assets/img/SimilarCasesIcon.svg";

export const SimilarCasesCard = () => {
  const [expandSimilarCases, setExpandSimilarCases] = useState(false);
  const [selectedSimilarCase, setSelectedSimilarCase] = useState(null);

  const { similarCases, loading, error } = useSimilarCasesData();

  useEffect(() => {
    if (!loading) {
      setSelectedSimilarCase(null);
    }
  }, [loading, similarCases]);

  const getButtonText = () => {
    if (loading) return "Loading...";

    if (similarCases?.length === 0) return "Nothing to show";

    if (!expandSimilarCases) return "Show Cases";

    if (selectedSimilarCase) return "Back";

    return "Close";
  };

  const onSimilarCasesButtonClick = () => {
    if (selectedSimilarCase) {
      setSelectedSimilarCase(null);
      return;
    }

    setExpandSimilarCases(!expandSimilarCases);
  };

  return (
    <SimilarCaseCollapse in={expandSimilarCases} collapsedSize={65}>
      <SimilarCasesCardBody>
        <HeaderWrapper
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <div>
            <Grid container alignItems="center">
              {loading ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                <SimilarCasesIcon aria-label="similar cases icon" />
              )}
              <Title>
                {error ? "Error fetching similar cases" : "Similar Cases"}
              </Title>
            </Grid>
          </div>
          <Button
            variant="contained"
            color="primary"
            data-qa="CP-Button-Expand-Similar-Cases"
            aria-label="Show/Hide Similar Cases"
            onClick={() => onSimilarCasesButtonClick()}
            disabled={loading || similarCases?.length === 0 || error}
          >
            {getButtonText()}
          </Button>
        </HeaderWrapper>
        {selectedSimilarCase ? (
          <SimilarCaseDetail similarCase={selectedSimilarCase} />
        ) : (
          <>
            <SimilarCasesFilters />
            <SimilarCasesTable
              setSelectedSimilarCase={setSelectedSimilarCase}
            />
          </>
        )}
      </SimilarCasesCardBody>
    </SimilarCaseCollapse>
  );
};

const SimilarCaseCollapse = styled(Collapse)`
  border-radius: 4px;
`;

const HeaderWrapper = styled(Grid)`
  padding-bottom: ${props => props.theme.spacing(2)};
`;

const SimilarCasesCardBody = styled(Card)`
  padding: ${props => props.theme.spacing(2)};
`;

const Title = styled(Typography)`
  padding-left: ${props => props.theme.spacing(2)};
`;
